import React from 'react';
import { NavLink } from 'react-router-dom';
import {Navbar, Nav, NavDropdown} from 'react-bootstrap';
import * as Icon from 'react-feather';
import './SideMenu.css';

class SideMenuDark extends React.Component {
    render() { 
        return (
            <div className={`sidemenu-area ${this.props.sideMenu ? 'sidemenu-toggle' : ''}`}>
                <Navbar className={`sidemenu ${this.props.sideMenu ? 'hide-nav-title' : ''}`} >
                    <Navbar.Collapse>
                        <Nav>
                        <NavLink to="/dashboard" className="nav-link">
                  <i className="fa fa-tachometer icon"></i>
                  <span className="title">Dashboard</span>
                </NavLink>
                <NavLink to="/addStudent" className="nav-link">
                  <Icon.FileText className="icon" />
                  <span className="title">Add Student</span>
                </NavLink>
                <NavLink to="/studentsList" className="nav-link">
                  <Icon.User className="icon" />
                  <span className="title">Students </span>
                </NavLink>
                <NavLink to="/pendingRegistration" className="nav-link">
                  <Icon.User className="icon" />
                  <span className="title">Pending Registrations </span>
                </NavLink>
{/* 
                <NavLink to="/assingClass" className="nav-link">
                  <Icon.User className="icon" />
                  <span className="title">Assign Class</span>
                </NavLink> */}
                <NavLink to="/paymentDue" className="nav-link">
                  <Icon.User className="icon" />
                  <span className="title">Payment Due</span>
                </NavLink>
                
                <NavLink to="/feeSetup" className="nav-link">
                  <Icon.User className="icon" />
                  <span className="title">Fee Setup</span>
                </NavLink>
                <NavLink to="/notifications" className="nav-link">
                  <Icon.User className="icon" />
                  <span className="title">Notifications </span>
                </NavLink>
                <NavLink to="/pendingPayments" className="nav-link">
                  <Icon.Database className="icon" />
                  <span className="title">Pending Payments </span>
                </NavLink>

                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </div>
        );
    }
}

export default SideMenuDark;